export enum CacheKeyEnum {
    mainToken = "c-token",
    alterToken = "c-alter-token"
}